import React from 'react';
import { Card, Typography, Table, Empty, Spin } from 'antd';
import { MockObjectItem, ObjectBasicInfo } from '@/types/semanticDataMap';

const { Title, Text } = Typography;

interface ObjectInfoProps {
  selectedObject: MockObjectItem | null;
  objectInfo: ObjectBasicInfo | null;
  isLoading?: boolean;
}

const ObjectInfo: React.FC<ObjectInfoProps> = ({ selectedObject, objectInfo, isLoading }) => {
  const relationshipColumns = [
    {
      title: '关系类型',
      dataIndex: 'linkType',
      key: 'linkType',
      className: 'text-sm',
    },
    {
      title: '关系中角色',
      dataIndex: 'role',
      key: 'role',
      className: 'text-sm',
    },
    {
      title: '关系中链接对象',
      dataIndex: 'linkedElementName',
      key: 'linkedElementName',
      className: 'text-sm',
      render: (name: string, record: { linkedElementId: number }) =>
        `${name} (ID: ${record.linkedElementId})`,
    },
  ];

  return (
    <Card className="mb-6 border border-gray-200 shadow-sm">
      <Title level={5} className="mb-4 text-gray-700 font-medium">对象基本信息</Title>
      {isLoading ? (
        <div className="flex justify-center py-6"><Spin /></div>
      ) : selectedObject?.name ? (
        <>
          <div className="mb-3 text-sm">
            <Text strong className="text-gray-600">对象名称：</Text>
            <Text className="text-gray-800 ml-1">{selectedObject?.name}</Text>
          </div>

          <div className="mb-3 text-sm">
            <Text strong className="text-gray-600">对象类型：</Text>
            <Text className="text-gray-800 ml-1">「对象」</Text>
          </div>

          <div className="mb-3 text-sm text-gray-700">
            对象的属性信息：共有 {objectInfo?.totalAttributeCount ?? '--'} 个属性，
            父类继承属性 {objectInfo?.inheritedAttributeCount ?? '--'} 个，
            展示关系作为属性展示的为 {objectInfo?.directAttributeCount ?? '--'} 个。
          </div>

          <div className="mb-4 text-sm text-gray-700">
            对象的关系信息：共有关系 {objectInfo?.relationCount ?? '--'} 个
          </div>

          <Table
            columns={relationshipColumns}
            dataSource={objectInfo?.links ?? []}
            pagination={false}
            size="small"
            className="mt-4 border border-gray-100"
            rowKey={(record) => `${record.linkedElementId}-${record.linkType}`}
            style={{ fontSize: '13px' }}
          />
        </>
      ) : (
        <Empty description={'暂无数据'} />
      )}
    </Card>
  );
};

export default ObjectInfo;
